import { type NormalizedCacheObject } from 'apollo-cache-inmemory';
import { type ApolloClient } from 'apollo-client';
import { type RetryLink } from 'apollo-link-retry';

export type ApolloClientType = ApolloClient<NormalizedCacheObject>;

interface CustomResolversContextUrl {
	stargateRoot: string;
	collaborationGraph?: string;
}

export type CustomFetch = (input: RequestInfo, init?: RequestInit) => Promise<Response>;

export interface CustomResolversContext {
	url: CustomResolversContextUrl;
	fetch: CustomFetch;
}

export type StatusCodeHandler = (response: Response) => void;
export interface StatusCodeHandlerMap {
	[statusCode: number]: StatusCodeHandler;
}

export interface ApolloClientInterface {
	retryLink?: RetryLink.Options;
	connectToDevTools?: boolean;

	// Object containing base URLs of services the graphql-client will need to interact with.
	// Includes URLs for both GraphQL services and services used by custom resolvers.
	url: CustomResolversContextUrl;

	getCloudId?: () => string;

	customFetch?: CustomFetch;
	statusCodeHandlers?: StatusCodeHandlerMap;
}

export enum TypeNames {
	USER = '_custom_User',
	USER_INPUT = '_custom_UserInput',
	USER_MANAGE_CONFIG = '_custom_UserManageConfig',
	USER_DETAILS_MUTABILITY_CONSTRAINTS = '_custom_UserDetailsMutabilityConstraints',
	USER_MANAGE_LINKED_ACCOUNTS = '_custom_UserManageLinkedAccounts',

	PRIVACY_VALUE = '_custom_PrivacyValue',
	PRIVACY_VALUE_INPUT = '_custom_PrivacyValueInput',
	PRIVACY_SETTINGS = '_custom_PrivacySettings',
	PRIVACY_SETTINGS_INPUT = '_custom_PrivacySettingsInput',
	PRIVACY_VALUES_CONFIG = '_custom_PrivacyValuesConfig',

	USER_PLACE = '_custom_UserPlace',
	USER_ORGANIZATION = '_custom_UserOrganization',

	PERMISSION_VALUE = '_custom_PermissionValue',
	AVATAR = '_custom_Avatar',
	MY_AVATAR = '_custom_MyAvatar',

	// Whether a team is active in slack
	TeamSlackStatus = '_custom_TeamSlackStatus',

	CLASSIC_APP = '_custom_ClassicApp',
	CLASSIC_APPS = '_custom_ClassicApps',
	MARKETPLACE_APP = '_custom_MarketplaceApp',
	CLASSIC_APP_INSTALLATION = '_custom_ClassicAppInstallation',
	MARKETPLACE_APP_PERMISSION = '_custom_MarketplaceAppPermission',
	MARKETPLACE_APP_PERMISSIONS = '_custom_MarketplaceAppPermissions',

	API_TOKEN = '_custom_ApiToken',
	SESSIONS_AND_DEVICES = '_custom_SessionsAndDevices',
	SESSION = '_custom_Session',
	DEVICE = '_custom_Device',
	ELEVATED_SESSION = '_custom_ElevatedSession',
	TSV_ENROLLMENT_DETAILS = '_custom_TsvEnrollmentDetails',
	CONTAINERS = '_custom_Containers',
	CONTAINER = '_custom_Container',
	CONTAINER_DETAILS = '_custom_ContainerDetails',
	COLOUR_SETTING = '_custom_ColourSetting',
	TEAM_LINK_ICON = '_custom_TeamLinkIcon',
}
